import React from 'react';
import { motion } from 'framer-motion';
import { Users, Star, Layers, Zap, CheckCircle2 } from 'lucide-react';
export function Stats() {
  const stats = [{
    icon: <Users className="w-5 h-5 md:w-6 md:h-6" data-id="element-298" />,
    value: '+500',
    label: 'profesores activos'
  }, {
    icon: <Star className="w-5 h-5 md:w-6 md:h-6 text-yellow-500 fill-yellow-500" data-id="element-299" />,
    value: '4.9/5',
    label: 'valoración promedio'
  }, {
    icon: <Layers className="w-5 h-5 md:w-6 md:h-6" data-id="element-300" />,
    value: '+120',
    label: 'recursos incluidos'
  }, {
    icon: <Zap className="w-5 h-5 md:w-6 md:h-6" data-id="element-301" />,
    value: '100%',
    label: 'práctico y aplicable'
  }];
  const uses = ['Clases particulares', 'Academias de idiomas', 'Clases online', 'Cursos grupales', 'Niveles básicos e intermedios'];
  return <section className="py-10 md:py-16 bg-white relative -mt-6 rounded-t-[2.5rem] z-20 shadow-[0_-10px_40px_rgba(0,0,0,0.1)]" data-id="element-302">
      <div className="container mx-auto px-4" data-id="element-303">
        <div className="max-w-4xl mx-auto text-center mb-8 md:mb-12" data-id="element-304">
          <h2 className="text-xl md:text-3xl font-bold text-brand-950 px-2" data-id="element-305">
            El sistema de clases listas para usar más completo del mercado
          </h2>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-6 max-w-6xl mx-auto mb-8 md:mb-16" data-id="element-306">
          {stats.map((stat, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.08
        }} className="bg-brand-50 rounded-xl md:rounded-2xl p-3 md:p-6 text-center border border-brand-100 shadow-sm" data-id="element-307">
              <div className="inline-flex items-center justify-center w-9 h-9 md:w-12 md:h-12 rounded-full bg-white text-brand-600 shadow-sm mb-2 md:mb-4" data-id="element-308">
                {stat.icon}
              </div>
              <div className="text-lg md:text-2xl font-extrabold text-brand-950 mb-0.5 md:mb-2" data-id="element-309">
                {stat.value}
              </div>
              <div className="text-xs md:text-sm text-brand-700 font-medium leading-tight" data-id="element-310">
                {stat.label}
              </div>
            </motion.div>)}
        </div>

        <div className="max-w-4xl mx-auto bg-brand-950 rounded-2xl md:rounded-3xl p-5 md:p-10 text-white shadow-xl overflow-hidden relative" data-id="element-311">
          <div className="absolute top-0 right-0 w-64 h-64 bg-brand-800 rounded-full blur-[80px] -mr-20 -mt-20 opacity-50" data-id="element-312"></div>

          <div className="relative z-10 flex flex-col md:flex-row items-center gap-5 md:gap-8" data-id="element-313">
            <div className="md:w-1/3 text-center md:text-left" data-id="element-314">
              <h3 className="text-lg md:text-2xl font-bold mb-1 md:mb-2" data-id="element-315">
                Utilizado en:
              </h3>
              <p className="text-brand-300 text-xs md:text-sm" data-id="element-316">
                Adaptable a cualquier formato
              </p>
            </div>

            <div className="md:w-2/3 grid grid-cols-1 sm:grid-cols-2 gap-2 md:gap-4 w-full" data-id="element-317">
              {uses.map((use, index) => <motion.div key={index} initial={{
              opacity: 0,
              x: -10
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: index * 0.08
            }} className="flex items-start gap-2 md:gap-3" data-id="element-318">
                  <CheckCircle2 className="w-4 h-4 md:w-5 md:h-5 text-accent-500 shrink-0 mt-0.5" data-id="element-319" />
                  <span className="text-sm md:text-base font-medium text-brand-50" data-id="element-320">
                    {use}
                  </span>
                </motion.div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}